import { FormEvent, useState } from "react";

import { t } from "@lingui/macro";
import { toast } from "react-toastify";
import styled, { useTheme } from "styled-components";

import Ratings from "components/feedback/form/ratings";
import { API_URL, httpRequestHandler } from "utils/utils";

const Container = styled.form`
  width: 438px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: ${(props) => props.theme.colors.feedbackBackgroundColor};
  padding: 16px;
  border-radius: ${(props) => props.theme.layout.borderRadius};
  @media only screen and (max-width: 768px) {
    width: 90%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
const RatingsHeader = styled.h4`
  font-size: 18px;
  font-family: CamptonSemiBold, sans-serif;
  color: ${(props) => props.theme.colors.feedbackColor} !important;
  text-align: center;
  padding: 0;
  margin: 24px 18px;
  line-height: 100%;
`;

const CommentsFields = styled.textarea`
  min-height: 110px;
  min-width: 100%;
  border-radius: 3px;
  padding: 9px 16px;
  color: #2a2f39;
  resize: none;
  border: ${(props) => props.theme.colors.infoBoxComments || "none"} !important;

  ::placeholder {
    color: #c4c4c4;
    font-size: 16px;
  }

  :focus {
    outline: none;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  height: 40px;
  border: none;
  margin-top: 16px;
  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.feedbackBtnColor};
  border-radius: ${(props) => props.theme.layout.borderRadius};
  font-family: CamptonSemiBold, sans-serif;
  font-size: 16px;

  :hover {
    cursor: pointer;
  }
`;

interface FeedbackFormProps {
  trackerId: string | string[] | undefined;
  show: boolean | undefined;
  onChangeVisibility: (v: boolean | undefined) => void;
}

const FeedBackForm = ({ trackerId, show, onChangeVisibility }: FeedbackFormProps) => {
  const { text }: any = useTheme();

  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");

  const sendFeedback = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    toast.clearWaitingQueue();
    toast.dismiss();

    if (rating < 1) {
      toast.error(t`Ratings fields is required`);
      return;
    }

    const res: any = await httpRequestHandler("reviews/", "POST", {
      tracker: `${API_URL}/trackers/${trackerId}/`,
      comment,
      rating,
    });
    if (res.status === 201) {
      toast.success(t`Comment sent`);
      onChangeVisibility(false);
    } else {
      toast.error(t`Failed to send feedback`);
    }
  };

  return (
    <>
      {show && (
        <Container onSubmit={(e: FormEvent<HTMLFormElement>) => sendFeedback(e)}>
          <RatingsHeader>{text.ratings}</RatingsHeader>
          <Ratings
            minRating={0}
            onSelect={(index) => {
              setRating(index);
            }}
          />
          <CommentsFields
            name="comments"
            placeholder={t`Add comment`}
            onChange={(e) => {
              setComment(e.target.value);
            }}
          />
          <SubmitButton type="submit">{t`Submit feedback`}</SubmitButton>
        </Container>
      )}
    </>
  );
};

export default FeedBackForm;

// TODO: in future cases should input fields or button be needed else where create a generic component for form fields and re-use.
